import { ApiReturn, get, post, put, deletes } from '@/lib/api';

/** 获取验证码 */
export function getVerCode(data) {
  return post('/auth/sms/sendOne', data, { returnResponse: true });
}
